// extracted by mini-css-extract-plugin
module.exports = {"root":"EventGroupListingPage_root__1NrYj"};